import {useState, useEffect} from 'react';
import {getPurchaseOrders} from "../../api/Api";
import {ExistingPurchaseOrderTable} from "../sales/ExistingPurchaseOrderTable";
import {PurchaseOrderStatusType} from "../../api/Constants";
import {matchSession} from "../../auth/sessionTools";

export const ExistingPurchaseOrder = ({session, onApiFail, refresh, onRefresh,  props}) => {
    const [purchaseOrders, setPurchaseOrders] = useState([]);

    useEffect(() => {
        getPurchaseOrders(PurchaseOrderStatusType.Complete, false).then(r => {
            const filteredPo = r.filter(line => matchSession(session, line.userId));
            setPurchaseOrders(filteredPo);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [onApiFail, session, refresh])


    const content = <ExistingPurchaseOrderTable items={purchaseOrders}  onRefresh={onRefresh} onApiFail={onApiFail}/>

    return content;
}